import React from 'react';

export default function CartDrawer({
  cart,
  currency,
  totalPrice,
  paymentMethods,
  orderInfo,
  setOrderInfo,
  selectedPayment,
  setSelectedPayment,
  updateQty,
  onClose,
  onSendWhatsApp
}) {
  return (
    <div style={modalOverlayStyle}>
      <div style={cartDrawerStyle}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <h3 style={{ margin: 0 }}>Your Cart</h3>
          <button onClick={onClose} style={{ border: 'none', background: 'none', fontSize: '1.2rem', cursor: 'pointer' }}>✕</button>
        </div>

        {/* Cart Item List */}
        <div style={{ maxHeight: '180px', overflowY: 'auto' }}>
          {cart.map((i) => (
            <div key={i.cartId} style={cartItemRow}>
              <div>
                <div style={{ fontWeight: '600', fontSize: '0.9rem' }}>{i.name}</div>
                <div style={{ fontSize: '0.8rem', color: '#6B7280' }}>{currency} {i.price * i.qty}</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <button onClick={() => updateQty(i.cartId, -1)} style={qtyBtn}>-</button>
                <span>{i.qty}</span>
                <button onClick={() => updateQty(i.cartId, 1)} style={qtyBtn}>+</button>
              </div>
            </div>
          ))}
        </div>

        <hr style={{ margin: '1rem 0', borderColor: '#F3F4F6' }} />

        {/* Total Price */}
        <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', fontSize: '1.1rem', marginBottom: '1rem' }}>
          <span>Total:</span>
          <span>{currency} {totalPrice}</span>
        </div>

        {/* Dynamic Payment Methods with Account Details */}
        <div style={{ marginBottom: '1rem' }}>
          <label style={{ fontWeight: '600', fontSize: '0.85rem', display: 'block', marginBottom: '0.5rem', color: '#374151' }}>
            Select Payment Method:
          </label>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
            {paymentMethods?.map((pm) => {
              const isSelected = selectedPayment === pm.id;
              return (
                <div
                  key={pm.id}
                  style={{
                    border: isSelected ? '2px solid #10B981' : '1px solid #E5E7EB',
                    background: isSelected ? '#ECFDF5' : '#FFF',
                    borderRadius: '8px',
                    padding: '0.6rem 0.8rem',
                    cursor: 'pointer'
                  }}
                  onClick={() => setSelectedPayment(pm.id)}
                >
                  <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                    <input
                      type="radio"
                      name="paymentMethod"
                      value={pm.id}
                      checked={isSelected}
                      onChange={(e) => setSelectedPayment(e.target.value)}
                      style={{ accentColor: '#10B981' }}
                    />
                    <span style={{ fontSize: '0.85rem', fontWeight: '500', color: '#111827' }}>{pm.name}</span>
                  </label>

                  {/* Display Account / Phone Number Details when Selected */}
                  {isSelected && pm.account && (
                    <div style={accountBoxStyle}>
                      <span style={{ fontSize: '0.75rem', color: '#047857', fontWeight: '500' }}>
                        {pm.instructions || 'Send payment to:'}
                      </span>
                      <strong style={{ fontSize: '0.9rem', color: '#065F46', display: 'block' }}>
                        {pm.account}
                      </strong>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Customer Information Inputs */}
        <div>
             <input
            type="text"
            placeholder="Delivery Address (e.g. Eastleigh 1st Ave)"
            style={inputStyle}
            value={orderInfo.location}
            onChange={(e) => setOrderInfo({ ...orderInfo, location: e.target.value })}
          />
          <input
            type="text"
            placeholder="Your Notes"
            style={inputStyle}
            value={orderInfo.notes}
            onChange={(e) => setOrderInfo({ ...orderInfo, notes: e.target.value })}
          />
       
          <button onClick={onSendWhatsApp} style={whatsappSubmitBtn}>
            Order via WhatsApp
          </button>
        </div>
      </div>
    </div>
  );
}

// Inline Styles
const modalOverlayStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 200 };
const cartDrawerStyle = { background: '#FFF', width: '100%', maxWidth: '480px', borderTopLeftRadius: '16px', borderTopRightRadius: '16px', padding: '1.25rem', boxSizing: 'border-box', maxHeight: '90vh', overflowY: 'auto' };
const cartItemRow = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' };
const qtyBtn = { border: '1px solid #D1D5DB', background: '#FFF', width: '28px', height: '28px', borderRadius: '4px', cursor: 'pointer' };
const accountBoxStyle = { marginTop: '0.4rem', padding: '0.4rem 0.6rem', background: '#D1FAE5', borderRadius: '6px', borderLeft: '3px solid #10B981' };
const inputStyle = { width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid #D1D5DB', marginBottom: '0.5rem', boxSizing: 'border-box' };
const whatsappSubmitBtn = { width: '100%', padding: '0.85rem', background: '#25D366', color: '#FFF', border: 'none', borderRadius: '8px', fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer', marginTop: '0.5rem' };